module.exports = new __parcel__URL__("rupture.dce0cff1.png").toString();